import {
    POS_SUCCESS,
    POS_LOADING,
  } from '../actions/POSActionNew';
  
  const initialState = {
    posData: [],
    isLoading: true
  };
  
  const POSReducerNew = (state = initialState, action = {}) => {
    switch (action.type) {
      case POS_SUCCESS:
        return { ...state, posData: action.data, isLoading: false };
      case POS_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default POSReducerNew;